var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransformer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H15.5V15.5H0.5V0.5Z",
    fill: "#E7EBF0",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81035 13.0001V16H7.81035V13.0001H8.81035Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81035 0V3H7.81035V0H8.81035Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31034 6.67285C6.75823 6.67285 5.5 7.93109 5.5 9.4832C5.5 11.0353 6.75823 12.2935 8.31034 12.2935C9.86246 12.2935 11.1207 11.0353 11.1207 9.4832C11.1207 7.93109 9.86246 6.67285 8.31034 6.67285ZM4.5 9.4832C4.5 7.3788 6.20595 5.67285 8.31034 5.67285C10.4147 5.67285 12.1207 7.3788 12.1207 9.4832C12.1207 11.5876 10.4147 13.2935 8.31034 13.2935C6.20595 13.2935 4.5 11.5876 4.5 9.4832Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31034 3.70703C6.75823 3.70703 5.5 4.96527 5.5 6.51738C5.5 8.06949 6.75823 9.32772 8.31034 9.32772C9.86246 9.32772 11.1207 8.06949 11.1207 6.51738C11.1207 4.96527 9.86246 3.70703 8.31034 3.70703ZM4.5 6.51738C4.5 4.41298 6.20595 2.70703 8.31034 2.70703C10.4147 2.70703 12.1207 4.41298 12.1207 6.51738C12.1207 8.62177 10.4147 10.3277 8.31034 10.3277C6.20595 10.3277 4.5 8.62177 4.5 6.51738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformer);
export default __webpack_public_path__ + "res/media/transformer.2fda5c886ccf82c981c31ad21dbeacdd.svg";
export { ForwardRef as ReactComponent };